import React from 'react';
import Title from './Title';
import contactImages from '../img/contact_images.png';
import Btn from './Btn';

export default function ContactSection() {
  return <>
    <div id='contact' className='contact_section'>
      <div className='contact_head py-5 mt-3 mt-md-0'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-8 col-lg-12 '>
              <Title mainClass="pt-0 pt-md-3 pt-lg-5 pb-0 pb-sm-5 mb-0 mb-sm-5"
                titleclass="lg heading text-start mb-3"
                desclass=" text-start"
                title={<>Contact Us</>}
                des="Already using Exquisite Moves? Sign in so we can tailor your support experience. If that’s not possible, we’d still like to hear from you!"
              />
            </div>
            <div className='col-sm-4 pb-5 pb-sm-0 mb-5 mb-sm-0 d-block d-lg-none'> 
            <div className='contact_mob_img '>
              <img className='img-fluid' src={contactImages} alt='img' />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='contact_form_wrapper pb-4 pb-sm-5 '>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-8'>
            <div className='formInner p-4 p-md-5' >
              <div className='form-group mb-3 mb-sm-4 pb-2' >
                <label>Your Email address</label>
                <input className='form-control' placeholder='John .eg' />
              </div>

              <div className='form-group mb-3 mb-sm-4 pb-2' >
                <label>Choose a Topic!</label>
                 <div className='selectionPickups' >
                   <ul>
                     <li>
                       <input type="radio" name="selection" id="s1"  />
                       <label htmlFor='s1' >Moving & Packing</label>
                     </li>
                     <li>
                       <input type="radio" name="selection" id="s2"  />
                       <label htmlFor='s2' >Junk Removal</label>
                     </li>
                     <li>
                       <input type="radio" name="selection" id="s3"  />
                       <label htmlFor='s3' >Donation Pickups</label>
                     </li>
                     <li>
                       <input type="radio" name="selection" id="s4"  />
                       <label htmlFor='s4' >Labor</label>
                     </li>
                     <li>
                       <input type="radio" name="selection" id="s5"  />
                       <label htmlFor='s5' >Why Exquisite Moves Services?</label>
                     </li>
                     <li>
                       <input type="radio" name="selection" id="s6"  />
                       <label htmlFor='s6' >Need help Signing in!</label>
                     </li>
                     <li>
                       <input type="radio" name="selection" id="s7"  />
                       <label htmlFor='s7' >Services Pricing</label>
                     </li>
                     <li>
                       <input type="radio" name="selection" id="s8"  />
                       <label htmlFor='s8' >Storage & Box Supplies</label>
                     </li>
                   </ul>
                 </div>
              </div>
              <div className='form-group mb-3 mb-sm-4 pb-2' >
                <label>Or Tell us what you need Help with?</label>
                <textarea className='form-control' placeholder='I want to Book Moving and Packing Services...' ></textarea>
              </div>
              <Btn class="position-relative mt-3 "
                arrow={true}
                wave={true}
                wavedark={true}
                href="#"
              >Get Help</Btn>

            </div>
          </div>
          <div className='col-lg-4 ps-md-4 d-none d-lg-block'>
            <div className='contact_desk_img '>
              <img src={contactImages} className="img-fluid" alt='img' />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </>
}
